import { gql } from "../__generated__/gql";

export const GET_CLIENT_WORKERS_AND_INVITATION_WORKERS = gql(`
    query getClientWorkers {
        getClientWorkers {
            ...WorkerInfoFields
        }
        workerInvitationsSent {
            ...InvitationFields
        }
    }
`);

export const GET_IJM_GROUPS = gql(`
    query GetIjmGroups {
        getIjmGroups {
            ...IjmGroupField
        }
    }
`);

gql(`
    fragment ClientUserFields on ClientUser {
        id
        firstName
        lastName
        phoneNumber
        email
        avatarUrl
        joinedAt
        canSignContracts
        isActive
        signatureCapacity
        signatureFunction
    }
`);

export const GET_CLIENT_USERS = gql(`
    query getClientUsers($clientId: ID!) {
        getClientUsers(clientId: $clientId) {
            ...ClientUserFields
        }
        clientInvitationsSent {
            ...InvitationFields
        }
    }
`);
